import { render, staticRenderFns } from "./HeaderHero.vue?vue&type=template&id=2c3c30d8&scoped=true"
import script from "./HeaderHero.vue?vue&type=script&lang=js"
export * from "./HeaderHero.vue?vue&type=script&lang=js"
import style0 from "./HeaderHero.vue?vue&type=style&index=0&id=2c3c30d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3c30d8",
  null
  
)

export default component.exports